import gql from 'graphql-tag';

export const StoreChainCreateQuery = gql`
	query StoreChainCreateQuery {
		editorialSectionTree(EditorialBrand: GOODS4HUB) {
            id
            name
            Parent {
                id
            }
            goodClasses {
                id
                shortname
                shortnameIta
                localId
                name
                nameIta
            }
        }
	}
`;


